var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_c('b-form-checkbox',{attrs:{"value":item.id},model:{value:(_vm.parceiro.naturezas_juridicas),callback:function ($$v) {_vm.$set(_vm.parceiro, "naturezas_juridicas", $$v)},expression:"parceiro.naturezas_juridicas"}},[_vm._v("\n      "+_vm._s(item.nome)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }